import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { stopResumeRecurringAction } from 'src/redux/actions/recurringActions';

const StopResumeRecurringDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.stopResumeRecurring]) {
        return state.dialog[DIALOGS.stopResumeRecurring];
      }
      return { opened: false, payload: null };
    });
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.put_recurring] === FORM_STATUS.processing,
  );

  const active = payload?.active;

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.stopResumeRecurring }));
  };

  const handleOk = () => {
    const { recurringId, active: targetActive } = payload;
    dispatch(stopResumeRecurringAction(recurringId, targetActive));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="stop-resume-subscription"
      open={opened}>
      <DialogTitle id="stop-resume-subscription">
        {t(lang, active ? 'menus.resume_subscription' : 'menus.stop_subscription')}
      </DialogTitle>
      <DialogContent dividers>
        {t(lang, active
          ? 'menus.resume_subscription_confirmation'
          : 'menus.stop_subscription_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default StopResumeRecurringDialog;
